import { useCallback, useEffect, useMemo, useState } from 'react'

import { Box, Container, Paper, SvgIcon, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { format } from 'date-fns'

import { ErrorBoundary } from '@scoir/error-reporter'
import { useScid } from 'store/user/hooks'
import { useDocumentDelegateName } from 'store/college/hooks'
import useTitle from 'common/use-title'
import api from 'common/api'
import useQuery from 'common/use-query-params'
import { useHistory } from 'components/ReactRouterProvider/context'
import Table, { SortDirection } from 'material/MuiTable'
import useTableContext from 'material/MuiTable/use-table-context'
import ViewDocumentTrigger from 'material/ViewDocumentTrigger'
import { DOCUMENT_LABELS } from 'common/document.labels.type'
import { documentRecord } from './applicants.types'
import { Search } from 'components/Search'

const useStyles = makeStyles((theme) => ({
  pageHeader: {
    fontSize: theme.typography.pxToRem(20),
    fontWeight: 500,
  },
  headerWrapper: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    marginBottom: theme.spacing(3),
    [theme.breakpoints.up('md')]: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
  },
  headerSubWrapper: {
    marginBottom: `${theme.spacing(1)}px`,
    [theme.breakpoints.up('md')]: {
      marginBottom: '0',
    },
  },
  delegateBox: {
    display: 'flex',
    alignItems: 'center',
    '& svg': {
      marginRight: theme.spacing(1),
    },
  },
}))

const Principle = () => {
  return (
    <SvgIcon
      style={{ fontSize: '50px' }}
      height="1em"
      width="1em"
      viewBox="0 0 55 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        id="Page-1"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="Admin_ChildEntity_Integrations"
          transform="translate(-59.000000, -489.000000)"
        >
          <g
            id="Principle"
            transform="translate(57.000000, 486.000000)"
          >
            <image
              id="icons8-arrow_pointing_left-copy-2"
              transform="translate(14.000000, 15.500000) rotate(-180.000000) translate(-14.000000, -15.500000) "
              x="0"
              y="1.5"
              width="28"
              height="28"
              xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAABGdBTUEAALGOfPtRkwAAAz1JREFUeAHt3MuS0kAUgGEuCzbqwrVPYs1ex50vA7ISV8jGx1GrnOU472D5DlZ5qbJYAJ4eyAwxSZ/uTqebIT8bIJdO8v1FgDA1gwE3BBBAAAEEEEAAAQQQQAABBBBAAAEEEEAAAQQQQCChwHK5XCTc3ElsanQSeyE7ccB/eyr7k2o/TiJAX/FN5OwB+oyfPUDf8bMGAN/wZzoFgb/HzxIA/Hv85AHAL+MnDQB+FT9ZAPDr8ZMEAL8Zv/MA4NvxOw0Avo7fWQDw3fA7CQC+O370AOD74UcNAL4/frQA4IfhRwngiX8dvqvnueawzWH54q/X68vJZPK7zTYfwLrm+K5Go9F8Npt90/Y3+BexEPzFYvFH26EzmP9YjuH1ZrO5Wa1Wz7TjCQoAvsY6GAyHw6fb7faDtqR3APA10tL8F6VnNU+8Anjif5Xz4KuenHZqaG8nPWmaUUx3DhCAfylvQuf+hls4Bt87BQA/2FddUQ0AvmrYagHr9wDwdVsx2tmWms/nVuPGVwD4NtZ482oDgB8PWBupEgB8jSzu/EoAGf6vxyas5zePcXq7aCWAvGmsROONo8hz+br9Wa55mOsf3AIEKgHMGEQIkAxcpTYAEQI1A1ZTz+HypjyTcd87jn0j139e2i5ByHjWz82O23kwiwV/DyiOkNNRIdHNfeMp6HhzRDjWiPvYKYDZJBHiwhejOQc4ivCuWFm5Nx9RP8rvAY+U5c559k/t4LwCmMHklbCQO9cIF/Ij/KceR7gyZrabdwAzGBFspPt5u93ux3g8nmtLqh9DbQN4Xje67smfpfwSsy8Gfzqdfrf5mXmtApgBfCPIKhdmvaabvLpa71PT2Kc4PegUdHwgh9OR67UjK/7xuH153DqAgZIIPhfw+mLrdJxRAhDBybp2oWgBiFDrq06MGoAIqndlgegBiFAxtk7oJAARrOalmZ0FIELJufFJpwGI0Oh+N6PzAES4s659kCQAEWrtbycmC0CE+ghJAxChGiF5ACKUI2QJQIT7CNkCEGEfIWsAImT6v6H3L8D9I35P+F8k0/PDz5uZts5mEUAAAQQQQAABBBBAAAEEEEAAAQQQQAABBBBAAIFuBP4Bw4wrGg+v75YAAAAASUVORK5CYII="
            ></image>
            <image
              id="icons8-university"
              x="29"
              y="0"
              width="30"
              height="30"
              xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAABGdBTUEAALGOfPtRkwAAAtVJREFUeAHtmzFu20AQRRUhgFzYuUoQ5CwG4hwgSK1GUKdO0BXkypUPkNZXcOEqt0iRNKmU7AIq6B9CHDDav0voCWAxEsW/+94MQBaczfhAAAIQgAAEIAABCEAAAhCAAAQuicCbKW52t9vdHA6Hu7T2L8f17+fz+eNqtfo1tf1MSsB2u/14hJ7h3wjsDP8xHfv1ev0svzVbNi9Auj0LiHyygElMRbMCBro9IiGf0/xUNCVgZLdHZTQ5FU0IOFO3R0U0NRXVBBTu9qiM6lNhF2Du9qiIalNhEVCw21+OhN9HSQfOs05FUQGFuv13gvgtHfl+/ykD7eR8TuV1/u4MH8tUnF1AwW7/nqA+LBaL++Vy+aMP8GazeZd+/5R++5qOD33njPyu2FScTUCnC/ueUkfue/ZPt0cv1FlP01PxXwJqdntUROtTMUpAp7ua6PaojM66m5mKsIApdHtUREtTMSig0zWT6vaojM7+qkxFRMCf6GYC5w3eyQSuUeSUUlORbpVPMn5bZDevLzr6Tub1ZcpWScDPlLDPR6Gp6N2AQ8BVSr7NR9pY7yIu+cv5JW++hb0joLIFBCCgMoHK8UwAAioTqBzPBFQWcPIprW9t6V7+5JPx0JPfpf9fmTIBSsRcI8AMXOMQoETMNQLMwDUOAUrEXCPADFzjEKBEzDUCzMA1DgFKxFwjwAxc4xCgRMw1AszANQ4BSsRcI8AMXOMQoETMNQLMwDUOAUrEXCPADFzjEKBEzDUCzMA1DgFKxFwjwAxc4xCgRMw1AszANQ4BSsRcI8AMXOMQoETMNQLMwDUOAUrEXCPADFzjEKBEzDUCzMA1DgFKxFwjwAxc4xCgRMw1AszANQ4BSsRcI8AMXOMQoETM9eB7wkPv9ZrXO7m4ofemmYDKShGAgMoEKsczAQioTKByPBOAgMoEiIcABCAAAQhAAAIQgAAEIAABCEAAAhCAgInAXy/26XNmo97pAAAAAElFTkSuQmCC"
            ></image>
          </g>
        </g>
      </g>
    </SvgIcon>
  )
}

type payload = {
  Total: number
  Documents: documentRecord[] | null
}

type applicantRecord = {
  Id: string
  FirstName: string
  LastName: string
  HighSchoolName: string
  DocumentType: string
  BatchDate: string
  BatchId: string
  TableKey: string
}

const mapDocuments = (docs: documentRecord[]): applicantRecord[] => {
  const mappedDocs = docs.map(
    (d: documentRecord): applicantRecord => ({
      Id: d.Id,
      FirstName: d.StudentInfo.FirstName,
      LastName: d.StudentInfo.LastName,
      HighSchoolName: d.StudentInfo.HighSchoolName,
      DocumentType: d.Type === 'OtherDocument' ? d.OtherLabel || 'Other Document' : DOCUMENT_LABELS[d.Type],
      BatchDate: formatBatchDate(d.SentDate),
      BatchId: d.BatchId,
      TableKey: `${d.Id}${d.BatchId}`,
    }),
  )
  return mappedDocs
}

const formatBatchDate = (dateStr: string | null) => {
  if (!dateStr) return ''
  const initialDate = new Date(dateStr)
  const date = initialDate.getUTCDate()
  const month = initialDate.getUTCMonth()
  const year = initialDate.getUTCFullYear()
  return format(new Date(year, month, date), 'MMM dd, yyyy')
}

export const Applicants = () => {
  useTitle('Scoir - Applicant Documents')
  const classes = useStyles()
  const [results, setResults] = useState<applicantRecord[]>([])
  const [hasError, setHasError] = useState(false)
  const [total, setTotal] = useState(0)
  const [refresh, setRefresh] = useState(false)
  const params = useQuery()
  const history = useHistory()
  const { page, pageSize, sort, sortDir, updateContext } = useTableContext({
    defaultSortKey: 'StudentInfo.LastName',
    defaultSortDir: 'asc',
  })

  const paramBatchId = params.get('batchId')
  const paramBatchDate = params.get('batchDate')
  const paramSearch = params.get('search')
  const paramFirstName = params.get('firstname')
  const paramLastName = params.get('lastname')

  const batchDateFormatted = useMemo(() => formatBatchDate(paramBatchDate), [paramBatchDate])

  const scid = useScid()
  const documentDelegateName = useDocumentDelegateName()

  const fetchResults = useCallback(
    (ctx: {
      page: number
      pageSize: number
      sort: string
      sortDir: SortDirection
      search?: string | null
      firstName: string | null
      lastName: string | null
    }) => {
      const queryParams: Record<string, string> = {
        sort: ctx.sortDir === 'desc' ? `-${ctx.sort}` : ctx.sort,
        from: `${ctx.page * ctx.pageSize}`,
        pageSize: `${ctx.pageSize}`,
      }
      if (ctx.search) {
        queryParams.search = ctx.search
      } else {
        if (ctx.firstName) {
          queryParams.firstname = ctx.firstName
        }

        if (ctx.lastName) {
          queryParams.lastname = ctx.lastName
        }
      }

      if (refresh) {
        queryParams.from = '0'
      }
      const params = new URLSearchParams(queryParams)
      setHasError(false)
      return api
        .get<payload>(
          `/api/colleges/${scid}/batches/${paramBatchId ? `${paramBatchId}/` : ''}documents?${params.toString()}`,
        )
        .then((results) => {
          setTotal(results.Total)
          setResults(results.Documents ? mapDocuments(results.Documents as documentRecord[]) : [])
        })
        .catch(() => {
          setHasError(true)
        })
    },
    [scid, paramBatchId],
  )
  useEffect(() => {
    if (refresh) {
      setRefresh(false)
      updateContext({ page: 0 })
    } else {
      fetchResults({
        page,
        pageSize,
        sort,
        sortDir,
        search: paramSearch,
        firstName: paramFirstName,
        lastName: paramLastName,
      })
    }
  }, [fetchResults, sort, sortDir, pageSize, page, paramSearch, paramFirstName, paramLastName, refresh])
  const handleSearch = useCallback(
    (search: string) => {
      params.delete('search')
      setRefresh(true)

      if (search) {
        params.append('search', search)
      }
      history.replace({ search: params.toString() })
    },
    [history, params],
  )

  return (
    <Box mb={5}>
      <ErrorBoundary>
        <Container maxWidth="lg">
          <Box>
            {documentDelegateName && (
              <Box
                my={2}
                className={classes.delegateBox}
              >
                <Principle />
                <Typography>
                  <strong>{documentDelegateName}</strong> is currently receiving your application materials &amp;
                  document batches.
                </Typography>
              </Box>
            )}
          </Box>
          <Box
            mt={4}
            className={classes.headerWrapper}
          >
            <Box
              mr={1}
              minWidth={250}
              className={classes.headerSubWrapper}
            >
              {!batchDateFormatted && (
                <Typography
                  variant="h6"
                  component="h1"
                  className={classes.pageHeader}
                >
                  Historical Applicants
                </Typography>
              )}
              {batchDateFormatted && (
                <Box>
                  <Typography
                    variant="h6"
                    component="h2"
                  >
                    Applicant Documents for {batchDateFormatted}
                  </Typography>
                </Box>
              )}
            </Box>
            <Search
              search={paramSearch ?? ''}
              prompt="Enter student name"
              onSubmit={handleSearch}
            />
          </Box>
          <Paper>
            <Table
              records={results}
              keyBy="TableKey"
              columns={[
                {
                  id: 'LastName',
                  label: 'Student',
                  render: ({ FirstName, LastName }) => `${LastName}, ${FirstName}`,
                  sortKey: 'StudentInfo.LastName',
                },
                {
                  id: 'HighSchool',
                  label: 'High School',
                  render: ({ HighSchoolName }) => HighSchoolName,
                  sortKey: 'StudentInfo.HighSchoolName',
                },
                {
                  id: 'DocumentType',
                  label: 'Document Type',
                  render: ({ DocumentType }) => DocumentType,
                  sortKey: 'Type',
                },
                {
                  id: 'BatchDate',
                  label: 'Batch Date',
                  render: ({ BatchDate }) => BatchDate,
                  sortKey: 'SentDate',
                },
                {
                  id: 'Expand',
                  label: 'Actions',
                  render: ({ Id, BatchId, DocumentType, FirstName, LastName }) => (
                    <ViewDocumentTrigger
                      firstName={FirstName}
                      lastName={LastName}
                      label={DocumentType}
                      scid={scid}
                      batchId={BatchId}
                      recordId={Id}
                    />
                  ),
                },
              ]}
              total={total}
              order={sortDir}
              orderBy={sort}
              page={page}
              rowsPerPage={pageSize}
              onSortChange={(sort, sortDir) =>
                updateContext({
                  page: 0,
                  sort,
                  sortDir,
                  pageSize,
                })
              }
              onPageSizeChange={(pageSize) =>
                updateContext({
                  page: 0,
                  pageSize,
                })
              }
              onPageChange={(page) => updateContext({ page })}
            />
            {hasError && (
              <Box
                mt={1}
                pb={2}
              >
                <Typography
                  role="alert"
                  color="error"
                  align="center"
                >
                  An error occurred while loading the applicants
                </Typography>
              </Box>
            )}
          </Paper>
        </Container>
      </ErrorBoundary>
    </Box>
  )
}

export default Applicants
